import { AnyAction } from 'redux';
import { App, Produkt, Produktlinie } from '@ps20-frontend/frontend-models';
import { produktReducer } from '@ps20-frontend/reducers';
import { ThhPferdActions } from '../thhPferdActions';

export const thhPferdProduktReducer = function (
  sectionState: Produkt = null,
  action: AnyAction,
): Produkt {
  const newSectionState = produktReducer(sectionState, action, App.THH_PFERD);
  switch (action.type) {
    case ThhPferdActions.BRUTTOPREISE_CALCULATED: {
      const produktlinien: Produktlinie[] = action.payload;
      return { ...newSectionState, produktlinien };
    }
    default:
      return newSectionState;
  }
};
